import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { WatchedIconWithTooltip } from 'chameleon/ui-stack/ui/assessments/icons-with-tooltip';
import styles from 'chameleon/legacy/src/components/assessment/Results/StudentPerformanceBar/styles.css';

const StudentVideoProgressBar = (props) => {
  const { id, watchedPercentage } = props;
  const roundedWatchedPercentage = Math.round(parseInt(watchedPercentage, 10));
  const barStyle = 'flex justify-center items-center p-6 rounded-full w-full';

  return (
    <div
      className={`flex h-10 bg-gray-400 rounded-full ${styles.performanceBarMinWidth}`}
    >
      {roundedWatchedPercentage === 0 && (
        <span className={`text-black bg-gray-400 ${barStyle}`}>
          Not Started
        </span>
      )}
      {roundedWatchedPercentage > 0 && roundedWatchedPercentage < 95 && (
        <span className={cn(`text-purple-700 bg-pink-200 ${barStyle}`)}>
          {`${roundedWatchedPercentage}% Watched`}
        </span>
      )}
      {roundedWatchedPercentage >= 95 && (
        <span className={`text-pink-200 bg-purple-700 ${barStyle}`}>
          {' '}
          <WatchedIconWithTooltip
            target={`student-video-${id}-progress-watched`}
            className="text-pink-200 mx-2"
            role="presentation"
          />{' '}
          Watched
        </span>
      )}
    </div>
  );
};

StudentVideoProgressBar.displayName = 'StudentVideoProgressBar';
StudentVideoProgressBar.defaultProps = {
  watchedPercentage: '0',
};
StudentVideoProgressBar.propTypes = {
  watchedPercentage: PropTypes.number,
};
export default StudentVideoProgressBar;
